import React from 'react';
import style from './layout.module.css';
import Navigation from './navigation';
import Footer from './footer';
import Grid from './grid';
import '../theme/theme.css';
import SEO from './seo';

export default function Layout({
  children,
  title,
  showBecomeContentCreator,
  hideNavigation,
  darkBG,
  showPopup,
  showTransparentNav,
  sectionNavigation,
  showDarkStyling
}) {
  return (
    <Grid row className={darkBG ? style.page_dark : style.page}>
      <SEO
        title={title}
        description="We at OhCleo have curated a diverse library of audio erotica and educational programs that are sexy & empowering."
      />
      {!hideNavigation && (
        <Navigation
          showBecomeContentCreator={showBecomeContentCreator}
          showTransparentNav={showTransparentNav}
          sectionNavigation={sectionNavigation}
          showDarkStyling={showDarkStyling}
        />
      )}
      {children}

      {!hideNavigation && <Footer />}
    </Grid>
  );
}
